// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._9bdsgpT8ROvAG6QxDhTJt{height:100vh;width:100vw;position:fixed;left:0;top:0}.UNIkXTZOoC9fL-oWBeC5_{height:100%;width:100%;background-color:#000;opacity:0;transition:opacity 600ms}._3sWEaOK1TJWNbuXBcDxspA{display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity 600ms}._3Aktwqf91L74a1YXzM-qmq{max-height:100vh;overflow-y:auto}._1SjnGP0PSsygLio3ytMWsH{max-width:600px;background-color:#fff;border-radius:1rem}._279OA8Sep0r4OqoondZ0ud{margin-bottom:20px}._3KMBVfU8Q9PIQO31hggIv6{height:30px;width:30px}._3OiZxE3QZPSAjPjq-TKlBY{background-color:#fff;border-radius:0;display:flex;min-width:120px;position:relative}._3zuIxDL3NBEq71PyXV-uQZ{color:#53565a;border:.0625rem solid #8e9092}.ZOK05yJs8KWzgdTrJcjYc{border-color:#ecedee;color:#000;display:block;font-size:.9375rem;padding:1.5625rem;text-align:center}._2p3IZJ9h-3-1knNVYKByuv{display:flex;flex-direction:column}", ""]);
// Exports
exports.locals = {
	"container": "_9bdsgpT8ROvAG6QxDhTJt",
	"overlay": "UNIkXTZOoC9fL-oWBeC5_",
	"content": "_3sWEaOK1TJWNbuXBcDxspA",
	"modalOverflow": "_3Aktwqf91L74a1YXzM-qmq",
	"modal": "_1SjnGP0PSsygLio3ytMWsH",
	"spacer": "_279OA8Sep0r4OqoondZ0ud",
	"infoIconSvg": "_3KMBVfU8Q9PIQO31hggIv6",
	"alert": "_3OiZxE3QZPSAjPjq-TKlBY",
	"alertNeutral": "_3zuIxDL3NBEq71PyXV-uQZ",
	"alertDialog": "ZOK05yJs8KWzgdTrJcjYc",
	"flex": "_2p3IZJ9h-3-1knNVYKByuv"
};
module.exports = exports;
